module.exports = __webpack_public_path__ + "img/clock.88665cc4.svg";